<template>
  <div>
    <div class="pb-8 sm:px-6">
      <div class="relative w-full sm:w-11/12 mx-auto">
        <div class="text-center">
          <!-- <h2 class="text-5xl tracking-tight font-extrabold text-indigo-700 mb-2">
            {{idxCount}}
          </h2> -->
          <h2
            class="mt-4 sm:mt-0 text-3xl sm:text-3xl tracking-tight font-extrabold text-gray-900"
          >
            Homes for Sale in our Market
          </h2>
          <p class="max-w-2xl mx-auto text-lg text-gray-500">
            Take advantage of the MOST valuable Real Estate Market in the US.
          </p>

          <div class="-mt-2 ">
            <button
              @click="openModal"
              type="button"
              class="inline-flex uppercase items-center px-6 py-2.5 border-solid border-2 border-indigo-900 text-base font-medium rounded-md shadow-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
            >
              <i class="text-white fas fa-search mr-1"></i> Search More Homes
            </button>
          </div>
        </div>

        <v-sheet style="background-color: transparent;" class="mx-auto mt-4">
          <div class="text-center">
            <div v-if="displayModal">
              <div class="mt-22 fixed z-10 inset-0 overflow-y-auto">
                <div
                  class="flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"
                >
                  <div
                    class="fixed inset-0 transition-opacity"
                    aria-hidden="true"
                  >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                  </div>

                  <!-- This element is to trick the browser into centering the modal contents. -->
                  <span
                    class="hidden sm:inline-block sm:align-middle sm:h-screen"
                    aria-hidden="true"
                    >&#8203;</span
                  >

                  <div
                    class="inline-block mx-auto w-full rounded-lg text-left overflow-hidden shadow-xl sm:w-1/2 mt-32 sm:mt-auto transform transition-all align-middle"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-headline"
                  >
                    <contact
                      :source="home"
                      :buyer="true"
                      v-on:event="redirectListing()"
                    ></contact>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="lg:w-9/12 md:w-full sm:w-full mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg-grid-cols-3 xl:grid-cols-3"
          >
            <div v-for="rental in newH.slice(0, numberFilter)" :key="rental.id">
              <single-card :rental="rental"></single-card>
            </div>
          </div>
        </v-sheet>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import SingleCard from "./SingleCard/SingleCard.vue";
import { mapGetters } from "vuex";
export default {
  components: { SingleCard },
  props: { status: Boolean },
  data: () => ({
    home: "home",
    displayModal: false,
    showMessage: false,
    loading: false,
    search: "",
    price: "",
    bed: "",
    bath: "",
    newH: [],
    numberFilter: 6,
    idxCount: ""
  }),

  created() {
    this.newHomes();
  },

  // mounted() {
  //   window.onscroll = () => {
  //     let bottomOfWindow =
  //       Math.max(
  //         window.pageYOffset,
  //         document.documentElement.scrollTop,
  //         document.body.scrollTop
  //       ) +
  //         window.innerHeight ===
  //       document.documentElement.offsetHeight;

  //     if (bottomOfWindow) {
  //       this.numberFilter += 4;
  //     }
  //   };
  // },

  computed: {
    ...mapGetters({
      userAuth: "userAuth"
    }),

    hbHouses() {
      return this.$store.getters.inventories;
    }
  },

  methods: {
    redirectRental() {
      this.$router.push({ name: "rentals" });
    },

    openModal() {
      this.$emit("openModal");

      // if (this.userAuth) {
      //   this.redirectListing();
      // } else if (!sessionStorage.getItem("modal")) {
      //   this.displayModal = true;
      // } else {
      //   this.redirectListing();
      // }
    },

    redirectListing() {
      this.displayModal = false;
      this.$router.push({ name: "listings" });
    },

    register() {
      this.$router.push({ name: "Register" });
    },

    newHomes() {
      window.axios.get("/api/newHomes").then(response => {
        this.newH = response.data[0];
        this.idxCount = response.data[1];
        this.$emit("count", this.idxCount);
      });
    },

    singleView(rental, newH) {
      this.$router.push({
        name: "SingleIDX",
        params: { id: rental.ListingKeyNumeric, rental, newH }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.pulse-button {
  box-shadow: 0 0 0 rgba(14, 118, 170, 0.7);
  -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
}
.pulse-button:hover {
  -webkit-animation: none;
  -moz-animation: none;
  -ms-animation: none;
  animation: none;
}

@-webkit-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-moz-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-ms-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}

.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 4px 16px;
}

#cards-container {
  overflow: hidden;
  margin: 20px;
}

.cards {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 99999px;
}

.card {
  /* Add shadows to create the "card" effect */
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  width: 235px;
  margin: 15px 7.5px;
}

.card:hover {
  -webkit-box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.card .img {
  max-width: 220px;
  height: 220px;
  display: inline-block;
}

#slide-left-container,
#slide-right-container {
  display: none;
}

#slide-left-container.active,
#slide-right-container.active {
  display: block;
  cursor: pointer;
}

.slide-left,
.slide-right {
  border-color: #fff;
  border-style: solid;
  height: 20px;
  width: 20px;
  margin-top: 30%;
}

.slide-left {
  border-width: 4px 0 0 4px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  margin-left: 40%;
}

.slide-right {
  border-width: 4px 4px 0 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin-left: 22%;
}

.wave-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
</style>
